import React from 'react';
import Raw from 'ui/Raw/Raw';

const President = ({
    title,
    body,
    figureImg,
    figureImgMobile,
    figureCaption,
}) => (
    <div className="careers-welcome careers-content-block">
        <div className="container">
            <div className="row">
                <div className="col-sm-4 hidden-xs">
                    <figure>
                        <img
                            className="img-circle img-responsive"
                            src={figureImg}
                            alt={figureCaption}
                        />
                        <figcaption className="text-center">
                            {figureCaption}
                        </figcaption>
                    </figure>
                </div>
                <div className="col-xs-12 col-sm-8 col-md-7 welcome-block-content">
                    <div>
                        <figure className="col-xs-4 pull-right visible-xs">
                            <img
                                className="img-circle img-responsive"
                                src={figureImgMobile}
                                alt={figureCaption}
                            />
                            <figcaption className="text-center">
                                {figureCaption}
                            </figcaption>
                        </figure>
                        <h2>{title}</h2>
                        <Raw content={body} />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default President;
